import type {
	AccessTokenModel,
	AuthAuthAuthGetParams,
	HTTPValidationError,
} from '@/shared/generated'
import type { UseQueryOptions } from '@/shared/lib/query-client'
import type { AxiosError } from 'axios'

import { useQuery } from '@tanstack/react-query'

import { client } from '@/shared/api/client'

// eslint-disable-next-line
export const useOauthExchange = (data: any) => {
	return useQuery({
		queryKey: ['oauth2'],
		queryFn: () =>
			client.instance.post<{ redirect_uri: string }, { redirect_uri: string }>(
				'/oauth2/auth',
				data,
				{
					withCredentials: true,
				}
			),
		retry: false,
	})
}

export const useExchangeCode = <T = AccessTokenModel>(
	query: AuthAuthAuthGetParams,
	options?: UseQueryOptions<
		AccessTokenModel,
		AxiosError<HTTPValidationError>,
		T
	>
) =>
	useQuery<AccessTokenModel, AxiosError<HTTPValidationError>, T>({
		queryKey: ['exchange'],
		queryFn: () => client.auth.authAuthAuthGet(query),
		retry: false,
		...(options || {}),
	})

export const SESSION_USER_QUERY_KEY = ['session', 'user'] as const

/**
 * Single source of truth for "who is logged in". A query-options factory so
 * route `beforeLoad` can `await queryClient.ensureQueryData(...)` it: awaiting
 * the real request leaves no `isLoading` window for the auth guard to misread.
 */
export const sessionQueries = {
	currentUser: () => ({
		queryKey: SESSION_USER_QUERY_KEY,
		queryFn: () => client.users.getCurrentUser(),
		// 401 means "not logged in", not "flaky network" - never retry it.
		retry: false,
		staleTime: Infinity,
	}),
}
